import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { isPresent } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class ReferrerOptionCreate extends React.Component {
  @observable slug = '';
  @observable text = '';
  @observable languageId = '';

  onClick() {
    if (isPresent(this.text) && isPresent(this.slug) && isPresent(this.languageId)) {
      const data = {
        text: this.text,
        slug: this.slug,
        languageId: this.languageId,
      };
      AppUI.referrerOptionStore.create({data: data}, this.props.afterCreate);
      this.text = '';
      this.slug = '';
      this.languageId = '';
    }
  }

  render() {
    return (
      <Grid columns={4} gap='sm' style={{marginBottom: '20px'}}>
        <input
          placeholder='Enter Text'
          value={this.text}
          onChange={el => this.text = el.target.value}
        />
        <input
          placeholder='Enter Slug'
          value={this.slug}
          onChange={el => this.slug = el.target.value}
        />
        <select
          style={{height: '34px'}}
          value={this.languageId}
          onChange={el => this.languageId = el.target.value}
        >
          <option />
          <option value='DE'>German</option>
          <option value='FR'>French</option>
          <option value='ES'>Spanish</option>
        </select>
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default ReferrerOptionCreate;
